export default {
  //serverURI: 'http://172.16.11.12:8091/',
  serverURI : '/',
  fixedLayout: false,
  hideLogoOnMobile: false
}



// WEBPACK FOOTER //
// ./src/config/index.js